import * as React from "react";
import { RouteProps, Route, Redirect } from "react-router-dom";
import { useResource, Resources } from "Translations/Resources";
import { useHasCurrentUserAccessRight } from "Hooks/useHasCurrentUserAccessRight";
import { AccessRightCodes } from "Components/Models/AccessRights";

type Props = {
  codes: AccessRightCodes[];
  fallbackUrl?: string;
} & RouteProps;

export const AuthorizedRoute: React.FunctionComponent<Props> = props => {
  const hasAccessRight = useHasCurrentUserAccessRight();

  const { codes: code, children, fallbackUrl, ...rest } = props;
  const { t } = useResource();
  const isAuthenticated = hasAccessRight(code);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          children
        ) : !fallbackUrl ? (
          <Redirect
            to={{
              pathname: `/${t(Resources.Routes.Error403)}`,
              state: { from: location },
            }}
          />
        ) : (
          <Redirect
            to={{
              pathname: fallbackUrl,
            }}
          />
        )
      }
    />
  );
};
